export default __webpack_public_path__ + "static/media/Phonk-Contrast-DEMO.00390c69.otf";